import { render, staticRenderFns } from "./ConfiguracionView.vue?vue&type=template&id=28222cdb"
import script from "./ConfiguracionView.vue?vue&type=script&lang=js"
export * from "./ConfiguracionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports